<template>

    <div class="users" ref="users">
    
        <div class="columns is-multiline organization">
    
            <div class="column is-6" style="height: 84vh; overflow-y: scroll;">

                <div class="card organization-form">

                    <header class="card-header has-background-dark">

                        <p class="card-header-title has-text-light">

                            <span>ORGANISATIONS</span>

                        </p>

                        <button class="button hide-show-archive is-small" @click="fetchData">{{ archived ? 'HIDE' : 'SHOW' }} ARCHIVED</button>

                        <button class="button hide-show-archive is-small" @click="buttonCreate">CREATE</button>

                    </header>

                </div>

                <organization-table :height="tabHeight" :selected.sync="selectedOrganization" :archived="archived"
               
                ref="organizationTable" @reFetchOrganization="fetchOrganizationTableData" :organizations.sync="organizations"></organization-table>

            </div>
            
            <div class="column is-6"  v-if="selectedOrganization" style="height: 87vh; overflow-y: scroll;">
            
                <div class="card organization-form">
            
                    <header class="card-header has-background-dark">
            
                        <p class="card-header-title has-text-light">
            
                            <span>{{ selectedOrganization.name | uppercase }}</span>
            
                        </p>
            
                        <div class="buttons" v-if="selectedOrganization">

                            <b-button size="is-small" type="is-danger" @click="onRemove(selectedOrganization, $event)">DELETE</b-button>

                            <b-button size="is-small" @click="selectedOrganization = null">CLOSE</b-button>
            
                        </div>
            
                    </header>

                    <br>

                    <user :organization="selectedOrganization" :organizations="organizations" :height="tabHeight" />

                </div>

            </div>

            
            <div class="column is-6"  v-if="create && selectedOrganization == null">
            
                <div class="card organization-form">
            
                    <header class="card-header has-background-dark">
            
                        <p class="card-header-title has-text-light">
            
                            <span>ORGANISATION FORM</span>

                            <button class="button is-small close-form" @click="create = false">CLOSE</button>
            
                        </p>
                        
                    </header>

                    <organization-form
                    :height="tabHeight"
                    :organization.sync="selectedOrganization"
                    @close="selectedOrganization = null"
                    @create-success="onCreateSuccess"
                    ></organization-form>


                </div>

            </div>



        </div>

    </div>

</template>

<script>

import OrganizationTable from "../partials/organizationTable";

import User from "../partials/user";

import { FirmService } from "@/services/firm.service";

import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

import OrganizationForm from "../partials/organizationForm";

export default {

  components: {

    OrganizationTable,
    
    User,

    OrganizationForm
  
  },
  
  data: () => ({
  
    firmService: FirmService,

    selectedOrganization: null,
    
    fullHeight: 0,
    
    creating: false,
    
    activeTab: 0,
    
    loading: false,
    
    archiving: false,
    
    restoring: false,
    
    deleting: false,

    archived: false,

    create: false,

    organizations: []

  }),
  computed: {
    tabHeight() {
      const spacesOnTop = 32 + 16; // Tabs height, Tab content top padding
      return this.fullHeight - spacesOnTop;
    },
    scrollableHeight() {
      return this.tabHeight - 44 - 56; // header height, footer height
    },


  },
  mounted() {
    this.fullHeight = this.$refs.users.clientHeight;
  },

  methods: {
    async restore() {
      this.restoring = true;

      try {
        const response = await this.firmService.restore(
          this.selectedOrganization.id
        );
        const firm = JsonDenormalizer.denormalize(response);

        this.$buefy.toast.open({
          message: "ORGANISATION RESTORED",
          type: "is-info",
          position: "is-top-center"
        });
        this.onRestoreSuccess(firm);
      } catch (err) {}

      this.restoring = false;
    },
    async archive() {
      this.archiving = true;

      try {
        const response = await this.firmService.archive(
          this.selectedOrganization.id
        );
        const firm = JsonDenormalizer.denormalize(response);

        this.$buefy.toast.open({
          message: "ORGANISATION ARCHIVED",
          type: "is-info",
          position: "is-top-center"
        });
        this.onArchiveSuccess(firm);
      } catch (err) {}

      this.archiving = false;
    },
    // onRemove() {
    //   this.$buefy.dialog.confirm({
    //     title: "Confirm",
    //     message: "Are you sure you want to <b>delete</b> this organisation?",
    //     confirmText: "Delete",
    //     type: "is-danger",
    //     hasIcon: true,
    //     onConfirm: () => {
    //       this.remove();
    //     }
    //   });
    // },
    // async remove() {
    //   this.deleting = true;

    //   try {
    //     await this.firmService.delete(this.selectedOrganization.id);

    //     this.$buefy.toast.open({
    //       message: "Organisation has been deleted.",
    //       type: "is-info",
    //       position: "is-top-right"
    //     });
    //     this.onRemoveSuccess();
    //   } catch (err) {}

    //   this.deleting = false;
    // },



    onRemove(firm, event) {
      
      this.$buefy.dialog.confirm({
        title: "Confirm",
        message: "Are you sure you want to <b>delete</b> this organisation?",
        confirmText: "Delete",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.remove(firm, event);
        }
      });
    },

    async remove(firm, event) {

      event.target.classList.toggle('is-loading');

      await FirmService.delete(firm.id).then(response => {

        this.$buefy.toast.open({
          message: "Organisation has been deleted.",
          type: "is-info",
          position: "is-top-right"
        });

        event.target.classList.toggle('is-loading');

        this.selectedOrganization = null;

        this.fetchOrganizationTableData();

        // this.$emit('reFetchOrganization');

      });

    },


    fetchOrganizationTableData(selected) {
      this.create = false;
      return this.$refs.organizationTable.getFirms();
      // return this.$refs.organizationTable.fetch();
    },
    onCreateSuccess() {
      this.fetchOrganizationTableData();
    },
    onUpdateSuccess(firm) {
      this.selectedOrganization = firm;
      this.fetchOrganizationTableData();
    },
    onArchiveSuccess(firm) {
      this.selectedOrganization = firm;
      this.fetchOrganizationTableData();
    },
    onRestoreSuccess(firm) {
      this.selectedOrganization = firm;
      this.fetchOrganizationTableData();
    },
    async onRemoveSuccess() {
      await this.fetchOrganizationTableData();
      this.selectedOrganization = null;
    },

    fetchData() {

      this.archived = !this.archived;
      
      this.$nextTick(() => {

        this.fetchOrganizationTableData();
      
      })

    },

    buttonCreate() {

      this.create = true;

      this.selectedOrganization = null;

    }

  }
};

</script>

<style scoped>
  .users {
      /*height: calc(88vh - 44px - 56px);*/
      .tab-content {
          padding: 16px 0px 0px 0px;
      }
  }

  .hide-show-archive{
    margin: 8px;
  }

  .close-form{
      position: absolute;
      right: 0px;
      margin-right: 9px;
  }

</style>


// WEBPACK FOOTER //
// src/components/pages/Users/list-new/includes/superadmin.vue